import React, { useState } from "react";
// 5888
import { Field } from "formik";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
//5889

import { TextField } from "formik-mui";
import propTypes from "prop-types";
import EnvironmentButtons from "../MaterialComponents/EnvironmentButtons";
import SelectMenu from "../MaterialComponents/SelectMenu";
import MaterialSlider from "../MaterialComponents/Slider";
import MoreInfo from "../MaterialComponents/MoreInfo";
import { display } from "@mui/system";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import HttpService from "../../Dashboard/duck/HttpService";

export const BasicDetails = ({
  environmentData,
  locationTypes,
  languageTypes,
  studyTypes,
  mediaData,
  includeStudyType,
  includeMediaType,
  respondentTypes,
  showCellsSlider = true, 
  userOptions,
}) => {

  const [languageOptions, setLanguageOptions] = useState([]);

const handleCountryChange = async (locationId, form) => {
  try {
    form.setFieldValue("language", "");
    const res = await HttpService.getLanguageList({ locationId });
    const fetchedLanguages = res.data || [];

    setLanguageOptions(fetchedLanguages);
    if (fetchedLanguages.length > 0) {
      form.setFieldValue("language", fetchedLanguages[0]);
    }
  } catch (err) {
    console.error("Failed to fetch languages:", err);
    setLanguageOptions([]);
    form.setFieldValue("language", "");
  }
};
  const panelSizeLabel = (
    <>
      Total respondents over per
      <div style={{ margin: "2px 0 -2px 6px" }}>
        <SelectMenu
          name="respondents"
          options={respondentTypes}
          variant="standard"
        />
      </div>
    </>
  );

  return (
    <>
      <Grid container spacing={3}>
<Grid item xs={12}>
  <EnvironmentButtons cards={environmentData?.data  || []} />
</Grid>     
   <Grid item xs={12}>
          <Typography variant="subtitle1" component={"span"}>
            Please give your study a name
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Field
            fullWidth
            name="name"
            component={TextField}
            label="Study name"
            variant="filled"
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle1" component={"span"}>
            Please choose the country and language you want to conduct the study
            in
          </Typography>
        </Grid>
<Grid item xs={12}>
  <Grid container spacing={3}>
    <Grid item md={6} xs={12}>
      <Field name="project_location">
        {({ field, form }) => (
          <SelectMenu
            {...field}
            name="project_location"
            label="Country"
            options={locationTypes}
            fullWidth
            valueKey="id"
            returnValue="object"
            onChange={(e) => {
              const selected = e.target.value;
              form.setFieldValue("project_location", selected);
              handleCountryChange(selected.id, form);
            }}
          />
        )}
      </Field>
    </Grid>
    <Grid item md={6} xs={12}>
      <SelectMenu
        name="language"
        label="Language"
        options={{ data: languageOptions }}
        fullWidth
        valueKey="id"
        returnValue="object"
      />
    </Grid>
  </Grid>
</Grid>
<Grid item xs={12}>
  <Typography variant="subtitle1" component={"span"}>
    Please select the Ops and Consultant Owners
  </Typography>
</Grid>

<Grid item xs={12}>
  <Grid container spacing={3}>
    <Grid item md={6} xs={12}>
      <SelectMenu
        name="override_owner_id"
        label="Ops Owner"
        options={{ data: userOptions }}
        valueKey="id"
        fullWidth
        returnValue="id"
      />
    </Grid>
    <Grid item md={6} xs={12}>
      <SelectMenu
        name="consultant_user_id"
        label="Consultant Owner"
        options={{ data: userOptions }}
        valueKey="id"
        fullWidth
        returnValue="id"
      />
    </Grid>
  </Grid>
</Grid>

        {includeMediaType ? (
          <>
            <Grid item xs={12}>
              <Typography variant="subtitle1" component={"span"}>
                {includeStudyType
                  ? "And please select the appropriate media and study types"
                  : "And please select the appropriate media type for your study"}
              </Typography>
            </Grid>
            <Grid item md={includeStudyType ? 6 : 12} xs={12}>
              <SelectMenu
                name="media_id"
                label="Media type"
                options={mediaData}
              />
            </Grid>
          </>
        ) : null}
        {showCellsSlider && (
          <> 
        <Grid item xs={12}>
          <Typography variant="subtitle1" component={"span"}>
            How many cells and how many respondents per cell?
          </Typography>
        </Grid>
        <Grid container wrap="nowrap" item xs={12}>
          <MaterialSlider
            name="number_of_cells"
            label="Number of cells"
            min={1}
            max={20}
            step={1}
            marks={[
              {
                value: 1,
                label: "1",
              },
              {
                value: 20,
                label: "20",
              },
            ]}
          />
          <MoreInfo popup="One cell for each testing variant" />
        </Grid>
        </>
        )}
        <Grid item xs={12}>
 
  <Field name="cell_steps">
    {({ field, form }) => {
      const currentValue = field.value || [];

      const handleChange = (step) => (event) => {
        if (event.target.checked) {
          form.setFieldValue("cell_steps", [...currentValue, step]);
        } else {
          form.setFieldValue(
            "cell_steps",
            currentValue.filter((v) => v !== step)
          );
        }
      };

     
    }}
  </Field>
</Grid>

        <Grid container wrap="nowrap" item xs={12}>
          <MaterialSlider
            name="panel_size"
            label={panelSizeLabel}
            min={100}
            max={1000}
            step={10}
            marks={[
              {
                value: 100,
                label: "100",
              },
              {
                value: 1000,
                label: "1000",
              },
            ]}
          />
          <MoreInfo popup="A respondent is the person who is taking part in the research" />
        </Grid>
      </Grid>
    </>
  );
};

BasicDetails.propTypes = {
  environmentData: propTypes.object,
  locationTypes: propTypes.object,
  languageTypes: propTypes.object,
  studyTypes: propTypes.object,
  mediaData: propTypes.object,
  respondentTypes: propTypes.object,
  includeStudyType: propTypes.bool,
  includeMediaType: propTypes.bool,
  showCellsSlider: propTypes.bool,
  userOptions: propTypes.array,
};